export enum TipoDato{
    VARCHAR = 1,
    BIGINT = 2,
    DATETIME = 3,
    BIT = 4,
    TEXT_AREA = 5,
    MULTIPLE = 6,
    MULTIPLE_CARACTERISTICAS = 7,
    VARIOS_REGISTROS = 9
}